module.exports = __webpack_public_path__ + "img/TRACTOR_CHASSIS TRAILER_LHD.eef49f03.jpg";